import LanguagesCard from './LanguagesCard.tsx';

export default LanguagesCard;
